import {mac} from './util'
import {postAction} from '../api/manage'

/**
 * 埋点
 * @param type 1-浏览SPU 2-浏览SKU 3-浏览品牌 4-浏览分类 5-搜索 6-colletion 30-viLocal点击品牌 31-viLocal点击商品
 * @param moduleId
 * @param moduleName
 * @param routerName 路由名
 * @param json
 * @Author cpgu 2022/08/12
 */
export async function buryingPoint(type, moduleId, moduleName, routerName, json = '') {
  try {
    if (!moduleId && !moduleName) {
      return
    }
    if (routerName === 'Home') {
      return
    }
    let param = {type: type, moduleId: moduleId, moduleName: moduleName, mac: mac()}
    if (localStorage.getItem('pro__userInfo')) {
      let userInfo = JSON.parse(localStorage.getItem('pro__userInfo'))
      param['userId'] = userInfo.value.id
    }
    if (localStorage.getItem('utm_source')) {
      param['utmSource'] = localStorage.getItem('utm_source')
    }
    if (localStorage.getItem('utm_medium')) {
      param['utmMedium'] = localStorage.getItem('utm_medium')
    }
    if (localStorage.getItem('utm_campaign')) {
      param['utmCampaign'] = localStorage.getItem('utm_campaign')
    }
    if (localStorage.getItem('utm_id')) {
      param['utmId'] = localStorage.getItem('utm_id')
    }
    if (localStorage.getItem('utm_term')) {
      param['utmTerm'] = decodeURIComponent(localStorage.getItem('utm_term'))
    }
    if (localStorage.getItem('utm_content')) {
      param['utmContent'] = localStorage.getItem('utm_content')
    }
    param['url'] = window.location.href
    param['extJson'] = json

    postAction(`v2/sp-log/save`, param).then((res) => {
      if (res.success) {
        console.log('log')
      }
    })
  } catch (e) {
    console.log('此错误不影响主业务，故不用提醒 。')
  }
}



// WEBPACK FOOTER //
// ./src/utils/log.js